import React from 'react';

// Card for `kind: "tobin.restaurant_info"`. Surfaced after a successful
// Apply on a job posting (HiringService.apply_job /
// JobListing.apply_for_job emit it as the second value of the result
// payload). Shows the place the user just applied to: name, cuisine,
// address, and the menu specialties as an indented list.
//
// Expected structured shape:
//   { kind: "tobin.restaurant_info",
//     name: "<restaurant>",
//     cuisine: "<cuisine>",
//     address: "<address>",
//     specialties: ["<dish1>", "<dish2>", …] }
export default function TobinRestaurantInfoCard({ structured }) {
  const specialties = structured.specialties || [];
  return (
    <div style={{
      marginBottom: '10px', padding: '12px', background: '#f8f9fa',
      borderRadius: '8px', border: '1px solid #e9ecef',
    }}>
      <div style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: '8px' }}>
        {structured.name}
      </div>
      {structured.cuisine && (
        <div style={{ fontSize: '0.9rem', marginBottom: '4px' }}>
          <strong>Cuisine:</strong> {structured.cuisine}
        </div>
      )}
      {structured.address && (
        <div style={{ fontSize: '0.9rem', marginBottom: '4px' }}>
          <strong>Address:</strong> {structured.address}
        </div>
      )}
      {specialties.length > 0 && (
        <>
          <div style={{ fontSize: '0.9rem', fontWeight: 700, marginTop: '10px', marginBottom: '4px' }}>
            Specialties
          </div>
          <ul style={{
            margin: 0, paddingLeft: '20px', fontSize: '0.9rem',
            color: '#444', lineHeight: 1.5,
          }}>
            {specialties.map((s, i) => (<li key={i}>{s}</li>))}
          </ul>
        </>
      )}
    </div>
  );
}
